import React, { Component } from "react";
import HeadBar from "./common/HeadBar";
import "../style/selfieInfo.scss";
import Kuang from "../icon/Kuang";
import People from "../icon/People";
import Photo from "../icon/Photo";
import api from "../apis/API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import * as UploadAPI from "../apis/UploadAPI";
import axios from "axios";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import RePhoto from "../icon/RePhoto";
import * as FacebookAPI from "../apis/FacebookAPI";
import * as UpdateOrderAPI from "../apis/UpdateOrderAPI";
import Loading from "./common/Loading";
import selefieMask1 from "../image/selfie-mask2.gif";
import selefieMask2 from "../image/selfie-mask4.gif";
import { routePage } from "../utils/routePage";
import Close from "../icon/Close";
import cardMask from "../image/card-mask.jpg";
import * as PostMessageAPI from "../apis/PostMessageAPI";
import * as CountPixelEventAPI from "../apis/CountPixelEventAPI";
import safeParse from "../utils/SafeParseLocalstrorage";
import { generateEventId } from "../utils/RandomGeneratorUtils.js";
import {
  DEFAULT_CONTENTS_TITLE,
  DEFAULT_CONTENTS_TITLE_2,
  DEFAULT_CONTENT_IDS,
  DEFAULT_CONTENT_TYPE,
} from "../constants/ApiEndpointConstants.js";

import { lang } from "../utils/lang";

import nod from "../image/selfie-nod.gif";
import shake from "../image/selfie-shake.gif";
import getAd from "../utils/GetAd.js";
import faceMaskImg from "../image/face-mask.png";

class SelfieInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video: false, //是否授权
      recording: false, // 是否正在录制视频的状态
      videoURL: null, // 录制完成后视频的URL
      error: null, // 错误信息
      remainingTime: 15, //倒计时
      clickDown: false,
      videoReceiveURL: "",
      loadingShow: false,
      system: "Other",
      orderDetail: safeParse("orderDetail") || {},
      videoMask: false,
      isFirstVideo: safeParse("isFirstVideo" || 0),
      groupid: safeParse("groupid"),
      ad: getAd(),
      recordStep: 1,
      shakevideo: "", //摇头视频
      nodVideo: "", //点头视频
      videoTip: null,
      currentStep: 0, //当前亮起tick
    };
    this.startRecording = this.startRecording.bind(this);
    this.requestCameraPermission = this.requestCameraPermission.bind(this);
    this.stopRecording = this.stopRecording.bind(this);
    this.uploadVideo = this.uploadVideo.bind(this);
    this.resetRecordingState = this.resetRecordingState.bind(this);
    this.createVideo = this.createVideo.bind(this);
    this.removeAllVideos = this.removeAllVideos.bind(this);
    this.routeOrder = this.routeOrder.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.upload = this.upload.bind(this);
    this.showCardMask = this.showCardMask.bind(this);
    this.eventsAll = this.eventsAll.bind(this);
    this.changeVideoUrl = this.changeVideoUrl.bind(this);
    this.cleanupCamera = this.cleanupCamera.bind(this);
    this.startCountdown = this.startCountdown.bind(this);
    this.startAnimation = this.startAnimation.bind(this);
    this.stopAnimation = this.stopAnimation.bind(this);
    this.intervalAnimationId = null;

    // 创建用于引用视频元素的引用
    this.videoRef = React.createRef();
    this.receiveVideoRef = React.createRef();
    // 创建用于保存录制视频数据的数组
    this.chunks = [];
    // 创建一个MediaRecorder实例的引用
    this.mediaRecorder = null;
  }

  componentDidMount() {
    const system = this.getMobileSystem();
    console.log(system);
    this.setState({ system });
  }

  componentWillUnmount() {
    const stream = this.videoRef.current?.srcObject;
    this.stopAnimation();
    if (stream) {
      stream.getTracks().forEach((t) => t.stop());
    }
  }

  cleanupCamera() {
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((t) => t.stop());
    }
  }

  // 判断设备
  getMobileSystem() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(ua)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      return "iOS";
    }
    return "Other";
  }

  // 请求权限
  requestCameraPermission() {
    let { system } = this.state;
    if (system === "iOS") {
      navigator.mediaDevices
        .getUserMedia({ video: true }) // iOS 设备需要同时请求音频权限 audio: true
        .then((stream) => {
          this.setState({ video: true });
          this.videoRef.current.srcObject = stream;
          // mediaStreamTrack = stream;
        })
        .catch((error) => {
          console.error("Error accessing media devices: ", error);
          this.setState({
            error:
              "Erreur lors de l’accès aux périphériques multimédias. Veuillez vous assurer que votre caméra est connectée et que vous avez accordé l’autorisation d’y accéder.",
          });
        });
    } else {
      this.setState({ video: true });
    }
  }

  // 重置
  resetRecordingState() {
    this.chunks = []; // 清空录制数据数组
    clearInterval(this.intervalId); // 清除倒计时
    clearInterval(this.intervalAnimationId); // 清除倒计时
    this.setState({
      recording: false,
      remainingTime: 15, // 重新设置剩余时间为8秒
      video: false,
      videoReceiveURL: "",
      recordStep: 1,
      videoTip: null,
    });
    //
  }

  // 获取stream
  async getCameraStream() {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: false,
    });

    this.videoRef.current.srcObject = stream;
    await this.videoRef.current.play();

    return stream;
  }

  // 开始录制
  startRecording = async () => {
    let { recordStep, currentStep } = this.state;
    try {
      const stream = await this.getCameraStream();
      if (!stream) {
        console.error("No video stream available");
        return;
      }
      this.setState({ clickDown: true, videoTip: "Face forward" });
      // 开启光圈
      this.startAnimation();

      // ✅ 1️⃣ 明确 mimeType（非常关键）
      let options = {};
      if (MediaRecorder.isTypeSupported("video/mp4")) {
        options = { mimeType: "video/mp4" };
      } else if (MediaRecorder.isTypeSupported("video/webm")) {
        options = { mimeType: "video/webm" };
      }

      // ✅ 2️⃣ 创建 MediaRecorder（你之前漏了这一步）
      this.mediaRecorder = new MediaRecorder(stream, options);

      // ✅ 3️⃣ 每次录制前清空 chunks
      this.chunks = [];

      // ✅ 4️⃣ 绑定事件
      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          this.chunks.push(event.data);
        }
      };

      this.mediaRecorder.onstop = () => {
        const blob = new Blob(this.chunks, {
          type: this.mediaRecorder.mimeType,
        });
        this.chunks = [];
        this.uploadVideo(blob);
      };

      // ✅ 5️⃣ 最后再 start
      this.mediaRecorder.start();
      this.setState({ recording: true });

      this.startCountdown(recordStep);
    } catch (err) {
      console.error("startRecording failed:", err);
    }
  };

  startAnimation = () => {
    if (this.intervalAnimationId) {
      clearInterval(this.intervalAnimationId);
      this.intervalAnimationId = null;
    }

    this.intervalAnimationId = setInterval(() => {
      this.setState((prev) => ({
        currentStep: (prev.currentStep + 1) % 60,
      }));
    }, 30);
  };

  stopAnimation = () => {
    if (this.intervalAnimationId) {
      clearInterval(this.intervalAnimationId);
      this.intervalAnimationId = null;
    }
  };

  // 倒计时
  startCountdown(recordStep) {
    const step = parseInt(recordStep);
    this.intervalId = setInterval(() => {
      this.setState((prev) => {
        const time = prev.remainingTime - 1;
        let videoTip = prev.videoTip;
        if (time <= 0) {
          clearInterval(this.intervalId);
          this.stopRecording();
          return { remainingTime: 0, clickDown: false };
        }
        if (time <= 3) {
          videoTip = "Hold still";
        } else if (time <= 6) {
          videoTip = "Move closer again";
        } else if (time <= 9) {
          videoTip = "Hold still";
        } else if (time <= 12) {
          videoTip = "Move closer";
        }
        return {
          remainingTime: time,
          videoTip,
        };
      });
    }, 1000);
  }

  // 停止录制
  stopRecording() {
    clearInterval(this.intervalId);

    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      this.mediaRecorder.stop();
    }

    this.setState({
      recording: false,
      remainingTime: 15,
      videoTip: null,
      currentStep: 0, // 当前亮起的刻度
    });
  }

  // 上传视频
  uploadVideo = (videoBlob) => {
    let {
      orderDetail,
      isFirstVideo,
      groupid,
      recordStep,
      shakevideo,
      nodVideo,
    } = this.state;
    this.toggleShow();
    const formData = new FormData();
    formData.append("file", videoBlob);
    formData.append("snCode", this.state.orderDetail?.snCode);
    // PostMessageAPI.postMessage(`----[VIDEO]----${videoBlob}`);
    axios({
      url: BASE_URL + ApiEndpointConstants.UPLOAD,
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        console.log(res);
        var status = res.status;
        if (status === 200) {
          var url = res.data.data.url;
          orderDetail.userSelfPictureOrVideo = url;
          UpdateOrderAPI.updateOrderInformation(orderDetail);
          // if (recordStep === 1) {
          //   // 第一个视频：靠近
          //   this.setState({
          //     videoReceiveURL: url,
          //     shakevideo: url,
          //     recordStep: 2, // 👈 自动进入第二次录制
          //     remainingTime: 8,
          //   });
          // }
          if (recordStep === 1) {
            // 第二个视频：远离
            this.setState(
              {
                videoReceiveURL: url,
                nodVideo: url,
                recordStep: 3, // 👈 进入预览态
              },
              () => {
                const { isFirstVideo, shakevideo, nodVideo } = this.state;
                if (isFirstVideo < 1 && shakevideo !== "" && nodVideo !== "") {
                  this.eventsAll(orderDetail);
                }
              },
            );
          }
        }
      })
      .finally(() => {
        this.toggleShow();
      });
  };

  // 上传图片
  upload(e, type) {
    let { orderDetail, isFirstVideo, groupid } = this.state;
    var _that = this;

    [e.target.files[0]].forEach((fileItem, fileIndex) => {
      if (fileIndex > 0) return;
      let reads = new FileReader();
      reads?.readAsDataURL(fileItem);
      reads.onload = function (e) {
        const imgUrl = this.result;
        _that.toggleShow();
        UploadAPI.upload(imgUrl, orderDetail?.snCode).then((res) => {
          _that.toggleShow();
          var url = res.data.data.url;
          switch (type) {
            case "image":
              console.log(url);
              _that.setState({ videoReceiveURL: url, video: true }, () => {
                orderDetail.videoReceiveURL = url;
                if (isFirstVideo < 1) {
                  _that.eventsAll(orderDetail);
                }
                _that.toggleShow();
                UpdateOrderAPI.updateOrderInformation(orderDetail)
                  .then((res) => {
                    _that.toggleShow();
                  })
                  .catch((err) => {
                    _that.toggleShow();
                  });
              });
              break;

            default:
              break;
          }
        });
      };
    });
  }

  // 移除节点下的所有视频元素
  removeAllVideos() {
    const videoElements = document.querySelectorAll("video");
    videoElements.forEach((video) => {
      video.remove();
    });
  }

  //创建新的元素
  createVideo(src) {
    const videoElement = document.createElement("video");
    videoElement.src = BASE_URL + src;
    videoElement.autoplay = true;
    videoElement.controls = true;
    videoElement.type = "video/mp4";
    videoElement.playsInline = true;
    this.receiveVideoRef.current = videoElement;
    document.querySelector(".video-box").appendChild(videoElement);
  }

  // 切换视频展示
  changeVideoUrl(url) {
    this.setState({ videoReceiveURL: url });
  }

  routeOrder() {
    let { history, location } = this.props;
    let { videoReceiveURL, orderDetail, system, isFirstVideo, videoMask, ad } =
      this.state;
    if (isFirstVideo < 1) {
      this.setState({ isFirstVideo: 1, videoMask: !videoMask });
      this.resetRecordingState();
      localStorage.setItem("isFirstVideo", 1);
      return;
    }
    this.cleanupCamera();
    routePage(history, ad, "/proof");
    orderDetail.userSelfPictureOrVideo = videoReceiveURL;
    localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
  }

  eventsAll(orderDetail) {
    let { groupid } = this.state;
    const eventId = generateEventId("AddPaymentInfo", DEFAULT_CONTENT_IDS[0]);
    const eventParams = { value: orderDetail.amount };
    let userdata = {
      em: orderDetail.email,
      ph: orderDetail.phone,
      fn: orderDetail.firstName,
      ln: orderDetail.lastName,
      ct: orderDetail.city,
      st: orderDetail?.state?.value || orderDetail?.state,
      zp: orderDetail.zipCode,
      country: orderDetail.country,
    };
    FacebookAPI.submitFBConversionEvent(
      "AddPaymentInfo",
      eventParams,
      orderDetail.email ? userdata : null,
      eventId,
      null,
    );
    CountPixelEventAPI.countPixelEvent("AddPaymentInfo");
  }

  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  showCardMask() {
    this.setState({
      videoMask: !this.state.videoMask,
      video: false,
      videoReceiveURL: "",
    });
  }

  render() {
    const {
      video,
      remainingTime,
      clickDown,
      videoReceiveURL,
      system,
      videoMask,
      recordStep,
      shakevideo,
      nodVideo,
      videoTip,
      currentStep,
    } = this.state;

    const isPreview = recordStep === 3;
    const TICKS = 60;
    const lightIndex = (step) => step % TICKS;

    return (
      <React.Fragment>
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        {videoMask && (
          <div className="video-mask">
            <div className="card-box" onClick={this.showCardMask}>
              <Close size={24} color="#424242" className="close-Icon" />

              <div className="img">
                <img src={faceMaskImg} alt="" className="img-img" />
                <div className="color-box"></div>
              </div>

              <div className="title">Face Verification Failed</div>

              <p>
                Please face the camera directly and hold still for 3 seconds.
              </p>

              <p>
                Move a bit closer or further if needed, and make sure your full
                face is visible.
              </p>
            </div>
          </div>
        )}

        <div className="selfieInfo-page">
          <HeadBar {...this.props} />
          <div className="selfieInfo-box">
            {!video && <h2>Take a selfie to verify your identity</h2>}
            {video ? (
              <div className="camera-box">
                <div className="video-box">
                  {!isPreview ? (
                    <React.Fragment>
                      <div className="video-content">
                        <video
                          ref={this.videoRef}
                          autoPlay
                          playsInline={true}
                        ></video>
                        {/* 引导靠近、远离屏幕 */}
                        <div className="mask">
                          <img src={faceMaskImg} alt="" className="mask-bg" />
                          <div
                            className="face-ring"
                            style={{
                              animation: !clickDown
                                ? `ringPulse 1.5s infinite`
                                : "none",
                            }}
                          >
                            <div className="face-ring">
                              {[...Array(60)].map((_, i) => {
                                const LIGHT_WIDTH = 12;
                                // 光带宽度
                                let distance = Math.min(
                                  Math.abs(i - currentStep),
                                  60 - Math.abs(i - currentStep),
                                );
                                //distance 的计算
                                // i：当前刻度索引（0~59）
                                // currentStep：光带中心刻度索引（0~59）
                                // Math.abs(i - currentStep)：刻度到中心的绝对距离
                                // 60 - Math.abs(i - currentStep)：考虑圆形循环距离（光圈是闭环）
                                // Math.min(...)：取最短距离 → 光带可以从 59 → 0 顺畅扫光
                                // ✅ 这样保证了光带中心左右的刻度都亮，而不是在圆圈边缘断开

                                let opacity =
                                  distance < LIGHT_WIDTH
                                    ? 1 - (distance / LIGHT_WIDTH) * 0.8
                                    : 0.2;

                                return (
                                  <div
                                    key={i}
                                    className="tick"
                                    style={{
                                      transform: `rotate(${i * 6}deg) translateY(138px)`,
                                      opacity: clickDown ? opacity : 0.6,
                                    }}
                                  />
                                );
                              })}
                            </div>
                          </div>

                          {videoTip && (
                            <div className="tip-wrap">
                              <div className="text-tip" key={videoTip}>
                                {videoTip}
                              </div>
                            </div>
                          )}

                          {/* 文案 */}
                          <div className="txt">
                            {!videoTip && (
                              <p className="title">
                                Please keep your face inside the frame <br />{" "}
                                and face the camera
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {system === "iOS" ? (
                        <React.Fragment>
                          <video
                            ref={this.receiveVideoRef}
                            autoPlay={true}
                            type="video/mp4"
                            controls
                            className="receive-video"
                            muted={true}
                            playsInline={true}
                            src={BASE_URL + videoReceiveURL}
                          ></video>
                          <div className="tip-title"></div>
                        </React.Fragment>
                      ) : (
                        <img src={BASE_URL + videoReceiveURL} />
                      )}
                    </React.Fragment>
                  )}
                </div>
                {!isPreview ? (
                  <React.Fragment>
                    {clickDown ? (
                      <div className="remaining">
                        00 :{" "}
                        {remainingTime >= 10
                          ? remainingTime
                          : `0${remainingTime}`}
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      className={`start ${clickDown ? "unClick" : ""}`}
                      onClick={this.startRecording}
                    >
                      start
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="tip-title">
                      {/* <div
                        className={`tip-btn ${videoReceiveURL === shakevideo ? "isTip" : ""}`}
                        onClick={() => this.changeVideoUrl(shakevideo)}
                      >
                        Near
                      </div> */}
                      {/* <div
                        className={`tip-btn ${videoReceiveURL === nodVideo ? "isTip" : ""}`}
                        onClick={() => this.changeVideoUrl(nodVideo)}
                      >
                        Far
                      </div> */}
                    </div>

                    <div className="reload">
                      <RePhoto
                        size={20}
                        className="reload-icon"
                        onClick={this.resetRecordingState}
                      />
                    </div>
                    <div className="btn" onClick={this.routeOrder}>
                      {lang.next}
                    </div>
                  </React.Fragment>
                )}
              </div>
            ) : (
              <React.Fragment>
                {system === "iOS" ? (
                  <React.Fragment>
                    <div
                      className="takePhone-box"
                      onClick={this.requestCameraPermission}
                    >
                      <Kuang size={340} color="#6C8EEF" />
                      <People size={150} color="#E3E8EE" className="people" />
                      <div className="animate"></div>
                      <div className="video-box">
                        <Photo size={30} color="rgb(92, 94, 98)" />
                        <p
                          className="tip"
                          style={{ textAlign: "center", fontSize: "12px" }}
                        >
                          Upload the video in portrait format
                        </p>
                      </div>
                    </div>
                    <video src=""></video>{" "}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="takePhone-box">
                      <Kuang size={340} color="#6C8EEF" />
                      <People size={150} color="#E3E8EE" className="people" />
                      <div className="animate"></div>
                      <div className="video-box">
                        <Photo size={30} color="rgb(92, 94, 98)" />
                        <p className="tip">
                          Please upload a clear portrait photo.
                        </p>
                        <input
                          type="file"
                          className="file-box"
                          onChange={(e) => {
                            this.upload(e, "image");
                          }}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SelfieInfo;